module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2297aecefbf407f85e2541342961af8.png";